module.exports = __webpack_public_path__ + "img/close.bca1b3ae.png";